import React from 'react';
import EmployeeAssignments from '../components/EmployeeAssignments';

const Employees = () => {
  return <EmployeeAssignments />;
};

export default Employees; 